import { useEffect, useState } from "react";
import api from "../api/axios";

export const APPROVALS_EVENT = "approvals-refresh";

/** Сколько документов ждёт согласования (только для администратора): опрос раз в минуту + мгновенно по событию */
export function useApprovalsCount(enabled: boolean): number {
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setN(0);
      return;
    }
    let alive = true;
    const load = () => {
      if (!localStorage.getItem("token")) return;
      api
        .get<{ pending: number }>("/approvals/count")
        .then((r) => alive && setN(r.data.pending || 0))
        .catch(() => {});
    };
    load();
    const t = setInterval(load, 60000);
    window.addEventListener(APPROVALS_EVENT, load);
    return () => {
      alive = false;
      clearInterval(t);
      window.removeEventListener(APPROVALS_EVENT, load);
    };
  }, [enabled]);

  return n;
}
